// extracted by mini-css-extract-plugin
export default {"goodbye":"Goodbye_goodbye__uXLVu"};